// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _portaleUtilsData = {
  "gattiFuture": {
    "id": 1,
    "aziendaNome": "Gatti Filtrazioni Lubrificanti",
    "portaleNome": "GattiFuture",
    "primaryColor": "#2C285B",
    "secondaryColor": "#E7B142"
  },
  "praevidere": {
    "id": 2,
    "aziendaNome": "Praevidere",
    "portaleNome": "ForeSight",
    "primaryColor": "#312783",
    "secondaryColor": "#4AA0AF"
  },
  "sala": {
    "id": 3,
    "aziendaNome": "SALA S.R.L.",
    "portaleNome": "SALA",
    "primaryColor": "#232E58",
    "secondaryColor": "#E1E3E5"
  }
} as const